module.exports = __webpack_public_path__ + "resources/img/img_gridgain_apache2_m_jp.adcc5eca55ae233364becdf69d2d7e66.png";